module.exports = __webpack_public_path__ + "static/media/ks_background_blur.cc45dc2a.jpg";